// extracted by mini-css-extract-plugin
export default {"footer":"EditTopology_footer__UfQcc","content":"EditTopology_content__PENRB","root":"EditTopology_root__9HdU1"};